import * as Sentry from "@sentry/react";
import { IGNORE_ERRORS, TRACES_SAMPLE_RATE, scrubEvent } from "@gately/observability";

import { env } from "~/env";

export function buildWebSentryOptions(): Sentry.BrowserOptions | null {
  if (!env.VITE_SENTRY_DSN) return null;
  return {
    dsn: env.VITE_SENTRY_DSN,
    // MODE is a Vite build-time built-in, not a process/turbo env var.
    // eslint-disable-next-line turbo/no-undeclared-env-vars
    environment: env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    tracesSampleRate: TRACES_SAMPLE_RATE,
    ignoreErrors: IGNORE_ERRORS,
    sendDefaultPii: false,
    // NOTE: no replayIntegration — session replay lives in PostHog.
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend: (event) => scrubEvent(event),
    beforeSendTransaction: (event) => scrubEvent(event),
    // Scrubbed as they are recorded, too — a navigation crumb carries the
    // `/pass/<token>` URL (scrubString redacts it).
    beforeBreadcrumb: (breadcrumb) => scrubEvent(breadcrumb),
  };
}

export function initWebSentry(): void {
  const options = buildWebSentryOptions();
  if (!options) return;
  Sentry.init(options);
}

export function setSentryUser(id: string): void {
  Sentry.setUser({ id });
}

export function clearSentryUser(): void {
  Sentry.setUser(null);
}
